export class AppSettings{
  public static get apiEndpoint(): string{return 'api/';}
  public static get version(): string{return '1.2.1';}
  public static get versionNum(): string{return '121';}
  public static get produccion(): boolean{return true;} // setear a TRUE para cambiar produccion
}
